import {ApiClient} from './api'

export class AdyenTemporaryBasketService {
    baseUrl = '/api/adyen/pdp/temporary-baskets'
    apiClient = null

    constructor(token, customerId, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, customerId, null, site)
    }

    async createTemporaryBasket(product) {
        const res = await this.apiClient.post({
            body: JSON.stringify({product})
        })

        if (res.status >= 300) {
            const errorData = await res
                .json()
                .catch(() => ({errorMessage: 'Failed to create temporary basket'}))
            throw new Error(
                errorData.errorMessage || `Create temporary basket failed with status ${res.status}`
            )
        }

        return await res.json()
    }
}
